import Toast from '../../common/modules/toast';
import {debounceTime, fromEvent} from 'rxjs';
// jsRender Delimiter setting
$(($) => {
  $.views.settings.delimiters('<%', '%>');
  if (am4core) {
    am4core.addLicense('CH405441835');
    am4core.options.autoSetClassName = true;
    if (am4themes_animated) {
      am4core.useTheme(am4themes_animated);
    }
  }
  window.copyStatisticsLink = (hash) => {
    navigator.clipboard.writeText(location.origin + location.pathname + hash);
    Toast.add('Link copied.', 5000, 'primary');
  };
  $('.sp-toggle-filter-btn').on('click', (event) => {
    const onClass = 'pressed primary noborder';
    const offClass = 'secondary';
    const target = event.currentTarget.dataset.target;
    if ($(target).hasClass('hidden')) {
      $(event.currentTarget).removeClass(offClass).addClass(onClass);
      $(target).removeClass('hidden');
    } else {
      $(event.currentTarget).addClass(offClass).removeClass(onClass);
      $(target).addClass('hidden');
    }
  });
  $('.js-pc-btn-toggle-detail').on('click', function() {
    const cID = $(this).data('id');
    $(`#${cID}`).slideToggle('fast');
    $(this).toggleClass('open');
  });

  fromEvent(document, 'statistics_loaded').pipe(debounceTime(500)).subscribe(x => {
    if (location.hash.indexOf('#') === 0) {
      document.querySelector(location.hash).scrollIntoView({behavior: 'smooth', block: 'start'});
    }
  });
});
require('../../common/pages/profile/statistics/charts/score_graph.js');
require('../../common/pages/profile/statistics/charts/score_dist.js');
require('../../common/pages/profile/statistics/charts/score_diff.js');
require('../../common/pages/profile/statistics/charts/popularity_diff.js');
require('../../common/pages/profile/statistics/charts/genre_table.js');
require('../../common/pages/profile/statistics/charts/genre_chord_diagram.js');
require('../../common/pages/profile/statistics/date_range_picker.js');
